import { Box, Flex, Icon, Text } from '@chakra-ui/core';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { MdOutlineClose } from 'react-icons/md';
import { VideoCustomBackground } from './VideoBackgroundEffects/VideoCustomBackground';
import { VideoVirtualBackground } from './VideoBackgroundEffects/VideoVirtualBackground';
import { BlurSection } from './VideoBlurEffects/BlurSection';
import { BackgroundImage, BlurEffect } from './videoEffectTypes';

interface VideoEffectPanelContentProps {
  onBlurSelect: (effect: BlurEffect) => void;
  onBackgroundSelect: (id: BackgroundImage | null) => void;
  // eslint-disable-next-line
  onBackgroundRemove: () => void;
  onClose: () => void;
}

export const VideoEffectPanelContent = memo(function VideoEffectPanelContent({
  onBlurSelect,
  onBackgroundSelect,
  onClose,
}: VideoEffectPanelContentProps) {
  const { t } = useTranslation('videoInterviewEffect');
  return (
    <Box
      bg="white"
      borderRightRadius="sm"
      boxShadow="0 8px 32px rgba(0,0,0,0.14), 0 2px 8px rgba(0,0,0,0.08)"
      border="1px solid"
      borderColor="gray.100"
      h="100%"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      data-testid="video-effect-panel-content"
    >
      <Flex align="center" justify="space-between" px={4} py={3} flexShrink={0} borderBottom="1px solid" borderColor="gray.100">
        <Text fontSize="md" fontWeight="700">
          {t('title')}
        </Text>
        <Box
          as="button"
          onClick={onClose}
          w="24px"
          h="24px"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="gray.500"
          fontSize="18px"
          cursor="pointer"
          _hover={{ bg: 'gray.100', color: 'gray.700' }}
          outline="none"
          transition="all 0.15s"
        >
          <Icon as={MdOutlineClose} />
        </Box>
      </Flex>

      <Box px={4} pt={4} pb={4} display="flex" flexDirection="column" flex="1" minH="0" overflow="hidden">
        <>
          <BlurSection onBlurSelect={onBlurSelect} />
          <VideoCustomBackground onBackgroundSelect={onBackgroundSelect} />
          <VideoVirtualBackground onBackgroundSelect={onBackgroundSelect} />
        </>
      </Box>
    </Box>
  );
});
